import { User } from "@/types/user";
import { createSlice } from "@reduxjs/toolkit";

export interface userState {
  loginStatus: boolean,
  curUser: User,
}

const initialState: userState = {
  loginStatus: true,
  curUser: {} as User
}

export const userSlice = createSlice({
  name: 'userReducer',
  initialState: initialState,
  reducers: {
    setLoginStatus(state: userState, { payload }) {
      state.loginStatus = payload
    },
    setCurUser(state: userState, { payload }) {
      state.curUser = payload
    },
    resetUserState: () => initialState
  }
})

export const { setLoginStatus, setCurUser, resetUserState } = userSlice.actions
export default userSlice.reducer